import { useInView } from "react-intersection-observer"
import * as React from "react"
import * as styles from "./styles.module.scss"
import Button from "../Button"
import cx from "classnames"
import ScrollCta from "../ScrollCta"

export interface JourneyHeroProps {
  journey: any
  continueUrl?: string
}

const JourneyHero: React.FC<JourneyHeroProps> = ({ journey, continueUrl }) => {
  const [ref, inView] = useInView({
    threshold: 0,
  })

  return (
    <div className={styles.journeyHero} ref={ref}>
      <div className={styles.pagePadding}>
        <div className={styles.pictureWrapper}>
          <picture
            className={cx({
              [styles.picture]: true,
              [styles.inView]: inView,
            })}
          >
            <source
              media="(orientation: landscape)"
              srcSet={`${journey.bstImg.landscape.large.src} ${journey.bstImg.landscape.large.width}, ${journey.bstImg.landscape.small.src} ${journey.bstImg.landscape.small.width}`}
              sizes="100vw"
            />
            <source
              media="(orientation: portrait)"
              srcSet={`${journey.bstImg.portrait.large.src} ${journey.bstImg.portrait.large.width}, ${journey.bstImg.portrait.small.src} ${journey.bstImg.portrait.small.width}`}
              sizes="100vw"
            />
            <img
              className={styles.image}
              src={journey.bstImg.landscape.small.src}
              alt={journey.bstImg.alt}
            />
          </picture>
        </div>
        <div className={styles.copy}>
          <h6 className={styles.eyebrow}>{journey.subtitle}</h6>
          <div className={styles.header}>
            <h1 className={styles.heading}>{journey.title}</h1>
          </div>
          <div className={styles.descriptionWrapper}>
            <p className={styles.description}>{journey.descriptionText}</p>
          </div>
          <div className={styles.actions}>
            <div data-rate-context="true">
              <Button type="primary" size="xl" halo={true}>
                Continue
              </Button>
            </div>
          </div>
        </div>

        <ScrollCta cta="Learn more" />
      </div>
    </div>
  )
}

export default JourneyHero
